/**
 * ⚠ Reviewed content. Every statement here is a factual claim about how the
 * app behaves, so it must not drift from the code. If you change what is
 * stored, sent, or retained, change this too, and have the practice's
 * privacy officer re-read it. See COMPLIANCE.md.
 */
export const privacy = {
  title: 'Your privacy',
  updated: 'Last updated: August 2026',

  summary: {
    title: 'The short version',
    points: [
      'What you log stays on your phone.',
      'Families First Pediatrics cannot see it. Neither can we.',
      'No account, no name, no email, no phone number.',
      'No advertising, no analytics, no tracking, nothing sold or shared.',
    ],
  },

  sections: [
    {
      title: 'What this app stores',
      body: 'Feedings, diapers, weights, pumping, and sleep that you enter, plus your baby\'s nickname, birth date, due date, and feeding goals if you choose to add them. All of it is saved in your phone\'s own storage, the same way a notes app saves a note.',
    },
    {
      title: 'What we never ask for',
      body: 'There is no sign-up. We never ask for your name, your baby\'s legal name, your email, your phone number, your address, or your insurance details. A nickname is suggested instead of a real name on purpose, so nothing identifying needs to exist here at all.',
    },
    {
      title: 'Nobody at the practice is reading this',
      body: 'Your log is not sent to Families First Pediatrics, and it does not appear in your medical record. Your care team cannot open it, search it, or be notified by it. If you want them to see something in it, you show them yourself at a visit.',
    },
    {
      title: 'Connecting with your partner',
      body: 'If you connect a partner\'s phone, entries travel between your two phones through a relay service so they stay in step. Before anything leaves your phone it is encrypted with a key made from your invite code, and that code never leaves your two devices. The relay only ever holds scrambled text it has no way to read, labelled with a random code that is not linked to your name or your baby.',
    },
    {
      title: 'How long the relay keeps anything',
      body: 'Encrypted entries sit on the relay so the other phone can pick them up, and are deleted automatically after 120 days without activity. Disconnecting your partner stops any further sharing. Neither of these deletes anything from your own phone.',
    },
    {
      title: 'No tracking of any kind',
      body: 'There is no advertising, no analytics, no tracking pixels, no cookies for tracking, and no third-party code. The app is built so that it cannot load code from anywhere else even if someone tried to add it. We do not sell, rent, or share your information, because we do not have it.',
    },
    {
      title: 'You can take it with you or delete it',
      body: 'Settings has a backup button that saves everything to a file you keep, and a restore button that reads one back. Erase all data removes everything from this phone immediately. Deleting the app, or clearing your browser data, also erases it, which is why the backup file is worth saving.',
    },
    {
      title: 'Children\'s information',
      body: 'This app is for a parent or caregiver to use. The information about your baby is yours, kept on your device, and is never collected by us.',
    },
    {
      title: 'This is not medical advice',
      body: 'The guidance here is educational and does not replace care from your pediatrician or lactation team. If you are worried about your baby, call the office.',
    },
    {
      title: 'Questions',
      body: 'Call the office and ask for the lactation team, and we will get you an answer.',
    },
  ],
};
